<template>
<div class="chapter">
<div class="inner_page">
<p class="h1" id="May29"><a id="page_26">Wednesday, May 29</a></p><a id="page_26">
<p class="h2">Port Dolomite</p>
<p class="author">Cedarville, Michigan</p>
<p class="noindent">We just finished supper. The captain is swinging the boat around to back into the dock at Cedarville, along the Lake Huron shore of Michigan’s Upper Peninsula, between the Mackinac Bridge and the village of DeTour. There’s a stone quarry here that started as an offshoot of U.S. Steel’s mine at Rogers City. The stone here at Port Dolomite is dolomitic limestone, or magnesium carbonate; the Rogers City limestone is calcium carbonate. The stone looks like little white rocks to me, though, and we’re going to load about fifteen thousand tons of them in the next four to five hours.</p>
<p class="indent">It’s now two hours later, and all the groceries have been stored. My back is sore from carrying the heavy boxes. Some stewards stand by and supervise the stowing of groceries, but I don’t feel right unless I pitch in and do my share.</p>
<p class="indent">Some of the crew went up to the casino in nearby Hessel for a little gambling. The wives of several other crewmembers were waiting when the boat docked. Other crewmembers walked up to the pay telephone located near the plant gate to call home. Charlie Brege, one of the oilers in the engine room, rode his bicycle into Cedarville to do a little shopping. It’s all part of the typical routine when we’re at a dock.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// May29.vue?52f204e4